export default __webpack_public_path__ + "static/media/avatar-3.d6c9b46f.png";